import { Component, OnInit } from '@angular/core';
import { environment } from '@src/environments/environment';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrl: './privacy-policy.component.scss',
    host: {
        class: 'app-privacy-policy'
    },
    standalone: false
})
export class PrivacyPolicyComponent implements OnInit {

  companyContactEmail = environment.companyContactEmail;

  constructor() { }

  ngOnInit() { }
}
